// extracted by mini-css-extract-plugin
module.exports = {"circularLoader":"CircularLoader_circularLoader__2xZZB","spin":"CircularLoader_spin__e7Ikw"};